import { Link } from "react-router-dom";
import { Home, Phone } from "lucide-react";
import { SITE } from "@/config/site";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable | FRELONS50" description="La page que vous recherchez n'existe pas." noindex />
      <section className="max-w-2xl mx-auto px-4 md:px-8 py-24 md:py-32 text-center">
        <p className="font-display text-7xl md:text-8xl font-extrabold text-brand-gold">404</p>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-black mt-4">Page introuvable</h1>
        <p className="mt-4 text-brand-text">La page que vous recherchez n'existe pas ou a été déplacée.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-brand-black text-white font-bold">
            <Home className="w-5 h-5" /> Retour à l'accueil
          </Link>
          <a href={SITE.phoneHref} className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-brand-gold text-brand-black font-bold">
            <Phone className="w-5 h-5" /> Appeler le {SITE.phoneDisplay}
          </a>
        </div>
      </section>
    </>
  );
}
